import { render, staticRenderFns } from "./RestStep.vue?vue&type=template&id=104c2b40"
import script from "./RestStep.vue?vue&type=script&lang=js"
export * from "./RestStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports